import type { EventName } from "@lit/react";
import { TimePicker as TimePickerElement, type TimePickerEventMap as _TimePickerEventMap, } from "@vaadin/time-picker/vaadin-time-picker.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { TimePickerElement, };
export type TimePickerEventMap = Readonly<{
    onValidated: EventName<_TimePickerEventMap["validated"]>;
    onChange: EventName<_TimePickerEventMap["change"]>;
    onInput: EventName<_TimePickerEventMap["input"]>;
    onInvalidChanged: EventName<_TimePickerEventMap["invalid-changed"]>;
    onValueChanged: EventName<_TimePickerEventMap["value-changed"]>;
    onOpenedChanged: EventName<_TimePickerEventMap["opened-changed"]>;
}>;
const events = { onValidated: "validated", onChange: "change", onInput: "input", onInvalidChanged: "invalid-changed", onValueChanged: "value-changed", onOpenedChanged: "opened-changed" } as TimePickerEventMap;
export type TimePickerProps = WebComponentProps<TimePickerElement, TimePickerEventMap>;
export const TimePicker = createComponent({
    elementClass: TimePickerElement, events, react: React, tagName: "vaadin-time-picker"
});
